import React from 'react';
import { Link } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import './footer.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';


function FooterComp() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section quick-links">
          <h2>Quick Links</h2>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/appointment">Appointment</Link></li>
            <li><Link to="/event">Event</Link></li>
            <li><Link to="/aboutus">About Us</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contactus">Contact Us</Link></li>
            <li><Link to="/signin">Login</Link></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:info@ehipassiko.com.au">info@ehipassiko.com.au</a></p>
          <p><a href="tel:+61451290085">Call +61 45 12 900 85</a></p>
          <p>Address: Ehipassiko Buddhist Center, 4 Schotters Rd, Mernda VIC 3754.</p>
        </div>

        <div className="footer-section social-media">
          <h2>Follow Us</h2>
          <div className="social-icons">
            <a 
              href="https://www.facebook.com/share/1DvAkDGw6d/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fa fa-facebook"></i>
            </a>

            <a 
              href="https://youtube.com/@ebcm-tv?si=oOEyt2zWewE46VOw"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fa fa-youtube"></i>
            </a>

       
            <a href="https://www.instagram.com/enlightened_path_fellowship/" 
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"><i className="fa fa-instagram"></i></a>

              <a
                href="https://www.tiktok.com/@ehipassikobuddhistcenter"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <i className="fab fa-tiktok"></i>
              </a>


          </div>
        </div>
      </div>

      <div className="footer-bottom"> 
        <p>&copy; 2025 Ehipassiko Buddhist Centre. All rights reserved.  |   Designed and Developed by 
          <a 
            className="glaxmore-link" 
            href="https://www.glaxmore.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            &ensp; GLAXMORE
          </a>
        </p>
        
      </div>
    </footer>
  );
}

export default FooterComp;
